import { getConflictingSets, IPlayerDataLocation, PlayerDataLocation } from 'Utility/DataConflictsHelper';
import {callNativeAsync, DataEndpoint, Native} from '@sgorg/mobile-dev-tools';
import IPlayerData from 'Player/IPlayerData';
import { FacebookNativeHandler } from 'Utility/SaveHandlers/FacebookNativeHandler';
import Game from 'Game';
import { playerEndpoint } from 'Player/DataManager';

export async function fetchDataConflicts(): Promise<IPlayerDataLocation[]> {
    let serverData: IPlayerDataLocation;
    // Once Facebook enabled Facebook takes precedence.
    // Get Facebook player data to compare with device data.
    if(Game.sdk.getFacebookAuthToken() !== '') {
        const facebookData = await getFacebookData();
        // If unable to fetch Facebook data while being Facebook enabled, return.
        // Don't check for data conflicts or show data conflicts screen.
        // Fail the process, showing error an message to player.
        // Continue with device data.
        if(!facebookData) return

        serverData = {
            location: PlayerDataLocation.FACEBOOK,
            playerData: facebookData
        }

    } else {
        // If not Facebook enabled get cloud/firebase data to compare with device data.
      const firebaseData = (await Native.data.loadData( DataEndpoint.Remote))[0];
        serverData = {
            location: PlayerDataLocation.CLOUD,
            playerData: firebaseData
        }
    }

    return getConflictingSets([
        { location: PlayerDataLocation.DEVICE, playerData: playerEndpoint },
        serverData,
    ]);
}

async function getFacebookData(): Promise<IPlayerData | undefined> {
    const facebookSaver = new FacebookNativeHandler();

    return facebookSaver.load();
}
